$(".cart1").click(function(){
    $(".new-model").show();
    $("body").css("overflow","hidden");
});

$(".goBack1").click(function() {
    $(".new-model").hide();
    $("body").css("overflow", "auto");
});


$(function () {
    // 读取 cookie 里面 webp support 信息
    function checkSupportWebp() {
        return /support_webp=([^;]+);?/.exec(document.cookie)[1] == 1;
    }

    function formatWebp(src) {
        if (!src || src.length === 0 || !checkSupportWebp()) {
            return src;
        }
        // 必须是webp的域名才进行替换
        if(src.search(/^https:\/\/webp\.cqggedm\.com/g) === -1){
            return src;
        }
        if (src.search(/\?x-oss-process=.*?\/format,webp/g) >=0) {
            return src;
        }
        if (src.search(/\?x-oss-process=/) >= 0) {
            return src + '/format,webp';
        }
        if (src.search(/\?/) >=0 ) {
            return src + '&x-oss-process=image/format,webp'
        }
        return src + '?x-oss-process=image/format,webp'
    }
});

//点击下拉框搜索
$(".iconsarr").on('click', function () {
if ($(".serachhead").hasClass('active')) {
    $(".serachhead").removeClass("active");
    $(".old-model .selectcont").slideUp()
} else {
    $(".serachhead").addClass("active");
    $(".old-model .selectcont").slideDown()
}
});

//点击see more
$(".featured-parts .operas").on('click', function () {
    if($('.featured-parts .featlist').hasClass('active')){
    $('.featured-parts .featlist').removeClass('active')
    $(this).find('span').first().text('Mehr')
    $(this).find('i').css('transform', 'rotate(0)')
    }else{
    $('.featured-parts .featlist').addClass('active')
    $(this).find('span').first().text('concluderen')
    $(this).find('i').css('transform', 'rotate(180deg)')
    }
})

//featured makes
$(".featMakes .operas").on('click', function () {
if($('.featMakes .feaMaCon').hasClass('featActive')){
    $('.featMakes .feaMaCon').removeClass('featActive')
    $(this).find('span').first().text('Mehr')
    $(this).find('i').css('transform', 'rotate(0)')
}else{
    $('.featMakes .feaMaCon').addClass('featActive')
    $(this).find('span').first().text('concluderen')
    $(this).find('i').css('transform', 'rotate(180deg)')
}
})

//左右切换
$(".carousel-control-prev").click(function () {
    $(this).find(".left").attr("src","/mobile/image/new-index/right-default.png").css("transform","rotate(-180deg)");
    $(".carousel-control-next").find(".right").attr("src","/mobile/image/new-index/right-active.png").css("transform","rotate(0deg)");
});
$(".carousel-control-next").click(function () {
    $(this).find(".right").attr("src","/mobile/image/new-index/right-default.png").css("transform","rotate(0deg)");
    $(".carousel-control-prev").find(".left").attr("src","/mobile/image/new-index/right-default.png").css("transform","rotate(-180deg)");
});

//v20201207新增产品点击样式
$(".featured li a,.new-index-box .hot-sale a,.new-index-box .hot-sale a,.new-other-box li a,.buyer-guide a,.new-arrival-box li a").on("click", function () {
    $(this).addClass("productClickActive");
});
$(document).on("click", ".clearance .goods .gli a", function () {
    $(this).find("img").addClass("productClickActive");
});
$(".new-index-box .commission a,.new-index-box .hot-sale.money,.customer-shared .customer-swiper .carousel-inner a").on("click", function () {
    $(this).addClass("productClickActive");
});
$(document).on("click", ".clearance.blogClear .goods a", function () {
    $(this).find("img").addClass("productClickActive");
});
$(".box-footer .modcontent .social li a").on("click", function () {
    $(this).addClass("boxfooterClickActive");
});
$(".box-footer .social:first-child li:nth-child(2) a").click(function () {
    $(this).addClass("productClickActive");
});



// index brand story
function showHideWord(num){
    $(".brand-seemore").eq(num).addClass("d-none").siblings().removeClass("d-none")
    if(num==0){
        $(".brand-intro").removeClass("brand-intro-status")
    }
    else{
        $(".brand-intro").addClass("brand-intro-status")
        $('body,html').animate({
            scrollTop: $(".brand-story").offset().top-200
        }, 0)
    }
}
